import Availability from "app/models/availability"
import { Params } from "./templateAvailabilities.reducer"

export enum Types {
  GET = "TEMPLATE_AVAILABILITIES_GET",
  GET_SUCCESS = "TEMPLATE_AVAILABILITIES_GET_SUCCESS",
  GET_FAIL = "TEMPLATE_AVAILABILITIES_GET_FAIL",
  RESET_PARAMS = "TEMPLATE_AVAILABILITIES_RESET_PARAMS",
}

export type Action = GetAvailabilities | GetAvailabilitiesSuccessAction | GetAvailabilitiesFailAction | ResetParams

export type GetAvailabilities = {
  payload: { templateId: number; params: Params }
  type: Types.GET
}

export type GetAvailabilitiesSuccessAction = {
  payload: { data: Availability[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetAvailabilitiesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type ResetParams = {
  type: Types.RESET_PARAMS
}

export function getAvailabilities(templateId: number, params: Params): GetAvailabilities {
  return {
    payload: { templateId, params },
    type: Types.GET,
  }
}

export function getAvailabilitiesSuccess(data: Availability[]): GetAvailabilitiesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getAvailabilitiesFail(errors: object): GetAvailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function resetParams(): ResetParams {
  return {
    type: Types.RESET_PARAMS,
  }
}
